import { 
    axios, 
    fetchArrayBufferByUrl,
    fetchTextByUrl
} from "./axios"

export async function getAuthData(params) {  // params = {data: xxx}
    let res = await axios({
        method: 'post',
        url: `https://websdkauth.faceunity.com/api/websdk/auth`,
        data: params,
        authorization: false,
        timeout: 5000,
    });
    if (res.data && res.data.code === 0 && res.data.data) {
        return res.data.data.cdata;
    } else if(res.status == 200 && res.data.code === 120005){
        return;
    } else if(res.status == 200) {
        throw res.data.message;
    }
}

// 获取 token, 其他请求均依赖于 token
export async function login() {
    try {
        let res = await axios({
            url: `/api/token`,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// (根据形象id)获取形象配置
export async function getAvatarInfo(params) {
    try {
        let res = await axios({
            url: `/api/items/avatar/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// (根据资源id)获取单个资源配置  =>  对应的批量接口 /items/resource/list
export async function getResourceById(params) {
    try {
        let res = await axios({
            url: `/api/items/resource/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// (根据项目id和版本)获取项目配置
export async function getProject(params) {
    try {
        let res = await axios({
            url: `/api/items/project/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// 获取资源快照
export async function getItemsSnapshot(params) {
    try {
        let res = await axios({
            url: `/api/items/snapshot/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// 公私域拆分
export async function getProjectV2(params) {
    try {
        let res = await axios({
            url: `/api/items/v2/project/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data
        } else {
            throw res
        }
    } catch (err) {}
}
// 获取资源快照
export async function getItemsSnapshotV2(params) {
    try {
        let res = await axios({
            url: `/api/items/v2/snapshot/query`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            let privateList = res.data.data.private;
            let publicList = res.data.data.public;
            const requests = [];
            if(publicList) {
                requests.push(axios({url: publicList, method: 'get'}));
            }
            if(privateList) {
                requests.push(axios({url: privateList, method: 'get'}))
            }
            const results = await Promise.all(requests);
            let list = [];
            for(let res of results) {
                list = list.concat(res.data.list);
            }
            return {list};
        } else {
            throw res
        }
    } catch (err) {}
}

// 获取自定义资源快照
export async function getCentreConfigV2(params) {
    try {
        let res = await axios({
            url: `/api/items/v2/centre-config`,
            params,
            authorization: null,
        })
        if (res.status == 200 && res.data.code === 0) {
            let url = res.data.data.editItemListPath;
            const result = await axios({url, method: 'get'})
            return result.data.map;
        } else {
            throw res
        }
    } catch (err) {}
}


// 获取问题集
export async function getTalkSkills(params) {
    try {
        let res = await axios({
            url: `/api/demo/config/skill`,
            params,
            authorization: true,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data;
        } else {
            throw res;
        }
    } catch (err) {}
}

// 存储虚拟人物信息
export async function saveAvatarInfo(params, data) {
    const fd = new FormData();
    fd.append('data', data);
    try {
        let res = await axios({
            method: 'post',
            url: `/api/items/avatar/create`,
            params,
            data: fd,
            headers: {'Content-Type': 'multipart/form-data'},
            authorization: false,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data;
        } else {
            throw res;
        }
    } catch (err) {}
}

export async function generateAvatar(params, image) {
    const fd = new FormData();
    fd.append('image', image);
    fd.append('version', '2022-03-01');
    try {
        let res = await axios({
            method: 'post',
            url: `/api/v1/pta/upload`,
            params,
            data: fd,
            headers: {'Content-Type': 'multipart/form-data'},
            authorization: false,
        })
        if (res.status == 200 && res.data.code === 0) {
            return res.data.data;
        } else {
            throw res;
        }
    } catch (err) {}
}

export async function downloadAvatarById(params) {
    let res = await axios({
        method: 'post',
        url: `/api/v1/pta/download`,
        params,
        authorization: false,
    })
    if (res.status == 200 && res.data.code === 0) {
        return res.data.data;
    } else if(res.status == 200 && res.data.code === 120005){
        return;
    } else if(res.status == 200) {
        throw res.data.message;
    }
}

const api = {
    fetchArrayBufferByUrl,
    fetchTextByUrl,
    getAuthData,
    login,
    getAvatarInfo,
    getResourceById,
    getProject,
    getItemsSnapshot,
    getProjectV2,
    getItemsSnapshotV2,
    getCentreConfigV2,
    getTalkSkills,
    saveAvatarInfo,
    generateAvatar,
    downloadAvatarById,
}

export default api;
